(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/rows-view-reduce.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/rows-view-reduce.js');
"use strict";

const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  useBetslipContext = _svs$components$tipse.useBetslipContext,
  Betslip = _svs$components$tipse.Betslip;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectSystemSize = svs.components.tipsen.engine.selectors.couponSelectors.selectSystemSize;
const currency = svs.utils.format.Currency;
const Rows = _ref => {
  let isExtraSmall = _ref.isExtraSmall,
    numberOfRows = _ref.numberOfRows,
    selectedSystemSize = _ref.selectedSystemSize;
  if (isExtraSmall) {
    return React.createElement(React.Fragment, null, React.createElement("span", null, React.createElement("span", null, numberOfRows)), React.createElement("span", null, ' ', "av", ' ', selectedSystemSize));
  }
  return React.createElement(React.Fragment, null, React.createElement("span", null, React.createElement("span", null, numberOfRows)), React.createElement("span", {
    className: "pg_betslip_row_value__selected_size"
  }, ' ', "av", ' ', selectedSystemSize));
};
const RowsViewReduce = _ref2 => {
  let numberOfRows = _ref2.numberOfRows,
    numRows = _ref2.numRows,
    children = _ref2.children;
  const _useBetslipContext = useBetslipContext(),
    isExtraSmall = _useBetslipContext.isExtraSmall,
    couponId = _useBetslipContext.couponId;
  const selectedSystemSize = useSelector(state => selectSystemSize(state, couponId, 0));
  const ariaLabel = selectedSystemSize > 0 ? "".concat(numRows, " rader av ").concat(selectedSystemSize) : "".concat(numRows, " rader");
  numberOfRows = currency(numberOfRows);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "pg_tipsen_betslip_system"
  }, children), React.createElement(Betslip.RowsDisplay, {
    ariaLabel: ariaLabel,
    label: "Rader"
  }, React.createElement(Rows, {
    isExtraSmall: isExtraSmall,
    numberOfRows: numberOfRows,
    selectedSystemSize: selectedSystemSize
  })));
};
Betslip.RowsViewReduce = RowsViewReduce;

 })(window);